export default (that) => [
  {
    field: "seq",
    width: 50,
    align: "center",
    type: "seq",
  },
  {
    type: "expand",
    minWidth: 50,
    align: "center",
    title: that.$l("INDEX.form_label_expand") || "展开",
    slots: {
      content: "expandContent",
    },
    showHeaderOverflow: true,
  },
  {
    title: that.$l("INDEX.material_choose_material_no") || "物料编号",
    field: "materialNo",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("INDEX.material_choose_search_chinese_name") || "物料名称",
    field: "materialName",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_Material_specification") || "物料规格",
    field: "materialSpec",
    minWidth: 150,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_Material_unit") || "物料单位",
    field: "materialUnit",
    minWidth: 80,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l("table_label_Customer_designated_supplier") || "客户指定供应商",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    slots: { default: "isSpecifyStatus" },
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_Total_demand_quantity") || "总需求量",
    field: "needQty",
    minWidth: 110,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_Total_purchased") || "已采购总数",
    field: "hasQty",
    minWidth: 150,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("table_label_Total_received") || "已入库总数",
    field: "stockQty",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("INDEX.table_label_modified_by") || "修改人",
    field: "modifyByName",
    minWidth: 160,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l("INDEX.table_label_modification_time") || "修改时间",
    field: "modifyDate",
    minWidth: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
